(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-template-size-chart"]) return;
  try {
    
  $('.size-guides-type').click(function(e){
    if(!$(this).hasClass('active')){
      $(this).siblings('.size-guides-type').removeClass('active');
      $(this).addClass('active');
       $(this).parent().parent().find('.pages-body .guides-list').removeClass('active');
      $(this).parent().parent().find('.pages-body .guides-list[data-value="'+$(this).data('value')+'"]').addClass('active');
    }
  })
  $('.type-size .type').click(function(e){
    if(!$(this).hasClass('active')){
      $(this).siblings('.type').removeClass('active');
      $(this).addClass('active');
      $(this).parent().parent().find('.list-table .table-type').removeClass('active');
      $(this).parent().parent().find('.list-table .table-type[data-value="'+$(this).data('value')+'"]').addClass('active');
    }
  })
  $('.title-tab').click(function(){
    if(!$(this).find('.item-title-tab').hasClass('active')){
      $('.title-tab').removeClass('active');
      $(this).addClass('active');
      $('.title-tab .plus-tab').html('+');
      $(this).find('.plus-tab').html('-');
      $('.title-tab .item-title-tab').removeClass('active')
      $(this).find('.item-title-tab').addClass('active');
      $('.content-tab .item-content-tab').removeClass('active');
      $(this).parent().find('.content-tab .item-content-tab').addClass('active');
    }
  })
  $('.size-guild').click(function(){
    $('.modal-size-guild').addClass('active');
    $('body').css('overflow','hidden');
  });
  $('.close-modal-size-guild').click(function(){
    $('.modal-size-guild').removeClass('active');
    $('body').css('overflow','inherit');
  });
  // $('.modal-size-guild').click(function(){
  //   $('.modal-size-guild').removeClass('active');
  //   $('body').css('overflow','inherit');
  // });

  } catch(e) { console.error(e); }
})();
})();
